import React from "react";
import { whyChooseUs } from "../mock";

const WhyChooseUs = () => {
  return (
    <section id="why" className="icg-section bg-[color:var(--icg-cream-soft)]">
      <div className="icg-container">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <span className="icg-eyebrow"><span className="icg-dot" /> Why choose us</span>
            <h2 className="font-display font-semibold tracking-tight mt-5"
                style={{ fontSize: "clamp(36px, 5vw, 64px)", lineHeight: 1.02 }}>
              Creative work,
              <br />
              <span className="font-serif-it text-[color:var(--icg-accent)]">delivered</span>.
            </h2>
            <p className="mt-6 text-[color:var(--icg-muted)] leading-relaxed max-w-sm">
              Creative design, professional web development and quality software — fast turnarounds
              at pricing that respects your budget.
            </p>
          </div>

          <div className="md:col-span-8 grid sm:grid-cols-2 gap-4">
            {whyChooseUs.map((w) => (
              <div
                key={w.id}
                className="icg-lift bg-[color:var(--icg-cream)] rounded-2xl p-6 border border-[color:var(--icg-line)]"
              >
                <div className="flex items-center gap-2 text-xs text-[color:var(--icg-muted)]">
                  <span className="icg-dot" /> 0{w.id}
                </div>
                <h3 className="mt-4 font-display font-semibold text-xl tracking-tight">
                  {w.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-[color:var(--icg-muted)]">
                  {w.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
